import { BASE_URL } from '@/config'

export async function getOperationalCapabilities() {
  try {
    const response = await fetch(
      `${BASE_URL}/graphs/operational-capabilities/`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message || 'Erro ao buscar capacidades operacionais'
      )
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Erro ao buscar capacidades operacionais:', error)
    throw error
  }
}

export async function getOperationalCapabilitiesByIdEnterprise(enterpriseId) {
  // console.log(
  //   'ID da empresa getOperationalCapabilitiesByIdEnterprise:',
  //   enterpriseId
  // )
  try {
    const response = await fetch(
      `${BASE_URL}/graphs/operational-capabilities/enterprise/${enterpriseId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message ||
          'Erro ao buscar capacidades operacionais da empresa'
      )
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Erro ao buscar capacidades operacionais da empresa:', error)
    throw error
  }
}
